import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { getThirdPartyIntegrations, toggleThirdPartyIntegration, updateThirdPartyIntegration } from './api';
import {
  ThirdPartyIntegrationState,
  ToggleThirdPartyIntegrationPayload,
  UpdateThirdPartyIntegrationPayload
} from './types';

export const THIRD_PARTY_INTEGRATIONS_QUERY_KEY = ['thirdPartyIntegrations'];

export function useGetThirdPartyIntegrations(options?: UseQueryOptions<ThirdPartyIntegrationState[], Error>) {
  return useQuery<ThirdPartyIntegrationState[]>({
    queryKey: THIRD_PARTY_INTEGRATIONS_QUERY_KEY,
    queryFn: getThirdPartyIntegrations,
    ...options
  });
}

export function useUpdateThirdPartyIntegration(provider: string) {
  return useMutation({
    mutationFn: (payload: UpdateThirdPartyIntegrationPayload) => updateThirdPartyIntegration(provider, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: THIRD_PARTY_INTEGRATIONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}

export function useToggleThirdPartyIntegration(provider: string) {
  return useMutation({
    mutationFn: (payload: ToggleThirdPartyIntegrationPayload) => toggleThirdPartyIntegration(provider, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: THIRD_PARTY_INTEGRATIONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}
